import React, { useState } from 'react';
import { Input, Button, message } from "antd";
import _axios from '../../unit/axios';
import backimg from '../../static/img/l-b1.jpg';
import starimg from '../../static/img/l-s.png';
import jiaoimg from '../../static/img/l-j.png';
import btnimg from '../../static/img/l-btn.png'
import { useNavigate } from 'react-router-dom';
import './css.css';
import { UserOutlined, UnlockOutlined } from '@ant-design/icons';

function Index() {
    
    const [account, setAccount] = useState('admin');  // admin
    const [password, setPassword] = useState('admin88');  // admin88
    const usernameChange = (e) => {
        setAccount(e.target.value);
    }
    const passwordChange = (e) => {
        setPassword(e.target.value);
    }

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();
    const submit = async () => {
        if (loading) {
            return;
        }
        if (!account || !password) {
            messageApi.open({
                type: 'error',
                content: '账号密码不能为空',
            })
            return;
        }
        setLoading(true);
        _axios.post('/api.v1/users', { account, password }).then(res => {
            if (res && res.code == 0) {
                localStorage.setItem('user', JSON.stringify(res.data));
                navigate('/page/user');
            } else {
                setLoading(false);
                messageApi.open({
                    type: 'error',
                    content: res.message,
                })
            }
        }).catch(err => {
            console.log(err)
            setLoading(false);
        })
    }
    
    return (
        <div style={{width: '100%',height: '100%', position: 'relative',display: 'flex', flexDirection: 'column' }}>
            <div style={{ position: 'relative', flex: 1, width: '100%', background: 'rgba(6,12,64,1)', overflow: 'hidden', display: 'flex',flexDirection: 'column', alignItems: 'end', justifyContent: 'center',  }}>
           
                <img src={backimg} style={{ height: '100%', width: '100%', position: 'absolute', top: 0, left: 0, }} alt='' />
                <img src={starimg} style={{ height: '50%', position: 'absolute', top: '24%', left: '5%', opacity: 0.66 }} alt='' />
                <div style={{color: 'white', position: 'absolute', fontSize: '42px', fontWeight: 'bold', left: '10%', top: '10%',}}>儿童心理测试平台</div>
                
                <div style={{ position: 'relative', padding: '48px', backgroundColor: '#14184b', width: '380px', marginRight: '10%', border: '2px solid #12285d', }}>
                    <img src={jiaoimg} style={{ position: 'absolute', top: '-2px', left: '-2px', }}></img>
                    <img src={jiaoimg} style={{ position: 'absolute', top: '-2px', right: '-2px', transform: 'rotate(90deg)', }}></img>
                    <img src={jiaoimg} style={{ position: 'absolute', bottom: '-2px', left: '-2px', transform: 'rotate(270deg)',}}></img>
                    <img src={jiaoimg} style={{ position: 'absolute', bottom: '-2px', right: '-2px', transform: 'rotate(180deg)',}}></img>

                    <div>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', textAlign: 'center', marginBottom: '12px', color: 'white', marginTop: '6px', }}>用户登录</div>
                        <div style={{marginBottom: '26px',marginBottom: '32px', }}>
                            <div style={{color: 'white',fontSize: '24px',marginBottom: '12px',}} ><UserOutlined style={{marginRight: '16px',}} />用户名</div>
                            <Input className='login-input' type="text" value={ account } onChange={usernameChange} placeholder='请输入账号' style={{ }}></Input>
                        </div>
                        <div style={{dmarginBottom: '26px',marginBottom: '52px', }}>
                            <div style={{color: 'white',fontSize: '24px',marginBottom: '12px',}}><UnlockOutlined style={{ marginRight: '16px',}} />密码</div>
                            <Input className='login-input' type="password" value={password} onChange={passwordChange} placeholder='请输入密码' style={{  }}></Input>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                        <img src={btnimg} onClick={submit} style={{ width: '100%',cursor: 'pointer', }}></img>
                    </div>
                </div>
            </div>

            <div style={{padding: '12px', textAlign: 'center', color: '#666', fontSize: '12px'}}>
                福建开三像技术服务有限公司&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;<a href="https://beian.miit.gov.cn">闽ICP备2023015373号</a>
            </div>

            {contextHolder}
        </div>    
    )
}

export default Index;